var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-indicator"},[_vm._v("\n    Laden…\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }